module.exports = __webpack_public_path__ + "static/media/check.a8f56702.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Editor/components/Result/images/check.svg
// module id = 368
// module chunks = 0